const { pow } = Math

const easeOutQuart = (num: number) => 1 - pow(1 - num, 3)

let currentId = ''

const animateScroll = ({
    targetPosition,
    initialPosition,
    duration,
}: {
    targetPosition: number
    initialPosition: number
    duration: number
}) => {
    const { requestAnimationFrame, cancelAnimationFrame } = window
    const initialScrollBehavior = document.documentElement.style.scrollBehavior
    const initialTargetPosition = targetPosition

    let startTimestamp: number
    let position: number
    let animationFrame: number
    let documentScrollHeight = document.documentElement.scrollHeight
    let maxAvailableScroll =
        documentScrollHeight - document.documentElement.clientHeight

    targetPosition =
        targetPosition > maxAvailableScroll
            ? maxAvailableScroll
            : targetPosition

    let amountOfPixelsToScroll = initialPosition - targetPosition

    const step = (timestamp: number) => {
        if (!startTimestamp) {
            startTimestamp = timestamp
            document.documentElement.style.scrollBehavior = 'auto'
        }

        if (document.documentElement.scrollHeight > documentScrollHeight) {
            documentScrollHeight = document.documentElement.scrollHeight
            maxAvailableScroll =
                documentScrollHeight - document.documentElement.clientHeight
            targetPosition =
                initialTargetPosition > maxAvailableScroll
                    ? maxAvailableScroll
                    : initialTargetPosition
            amountOfPixelsToScroll = initialPosition - targetPosition
        }

        const elapsed = timestamp - startTimestamp
        const relativeProgress = elapsed / duration
        const easedProgress = easeOutQuart(relativeProgress)

        position =
            initialPosition -
            amountOfPixelsToScroll * Math.min(easedProgress, 1)

        window.scrollTo(0, position)

        if (
            initialPosition !== maxAvailableScroll &&
            window.scrollY === maxAvailableScroll
        ) {
            cancelAnimationFrame(animationFrame)
            document.documentElement.style.scrollBehavior =
                initialScrollBehavior
            currentId = ''
            return
        }

        if (elapsed < duration) {
            animationFrame = requestAnimationFrame(step)
        } else {
            document.documentElement.style.scrollBehavior =
                initialScrollBehavior
            currentId = ''
        }
    }

    amountOfPixelsToScroll !== 0 &&
        (animationFrame = requestAnimationFrame(step))
}

const getElementPosition = (element: HTMLElement) => {
    const rect = element.getBoundingClientRect()

    return {
        left: rect.left + window.scrollX,
        top: rect.top + window.scrollY,
    }
}

export const scrollTo = ({
    id,
    position,
    duration = 3000,
    margin = 24,
    isMobile,
}: {
    id?: string
    position?: number
    duration?: number
    margin?: number
    isMobile?: boolean
}) => {
    if ((!id && position === undefined) || (id && currentId === id)) return
    if (id) currentId = id

    let targetPosition = 0
    const headerHeight = document.getElementById('header')?.offsetHeight

    if (id) {
        const element = id ? document.getElementById(id) : null

        if (!element) return

        if (headerHeight && isMobile) {
            targetPosition =
                getElementPosition(element).top - margin - headerHeight
        } else {
            targetPosition = getElementPosition(element).top - margin
        }
    } else if (position !== undefined) targetPosition = position

    animateScroll({
        targetPosition,
        initialPosition: window.scrollY,
        duration,
    })
}

export const scrollToTop = (duration = 500) => {
    scrollTo({ position: 0, duration, margin: 0 })
}

export const scrollModalToTop = () => {
    const modal = document.getElementById('modal')
    modal?.scrollTo({ top: 0, behavior: 'smooth' })
}
